import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  suiteTypes: [],
  search: "",
  totalCount: 0,
  rowsPerPage: 5,
  currentPage: 1,
  lastPage: 0,
};

export const suiteTypeSlice = createSlice({
    name: "suiteTypes",
    initialState,
    reducers: {
      addSuiteTypes(state, action) {
        state.suiteTypes.push(action.payload);
      },
      getSuiteTypes(state, action) {
        state.suiteTypes = action.payload.suiteTypes;
        state.totalCount = action.payload.totalCount;
        state.currentPage = action.payload.currentPage;
        state.lastPage = action.payload.lastPage;
        state.rowsPerPage = action.payload.rowsPerPage;
        state.search = action.payload.search;
      },
      getSuiteTypeById(state, action) {
        state.suiteTypes = action.payload;
      },
    },
  });
  
  export const actions = suiteTypeSlice.actions;
  export default suiteTypeSlice.reducer;